import { CircularProgress } from "@mui/material";
import { useContext } from "react";
import { createPortal } from "react-dom";
import { LanguageContext } from "../../../context/LanguageContext";
import { AvatarRingIcon } from "../../../assets/icons/icon";
import styles from "./styles.module.css";
import DotsLoader from "../DotsLoader";

const BusinessLoader = ({
  loadBusiness,
  fromAuth,
  fromRoute,
  /** When set during business switch: `{ name, imageUrl }` — shows switching overlay instead of spinner */
  switchingTo,
  /** Extra class for the fullscreen loader, e.g. a translucent overlay */
  className = "",
}) => {
  const [I18n] = useContext(LanguageContext);

  if (!loadBusiness) {
    return null;
  }

  const showSwitchOverlay =
    switchingTo &&
    !fromAuth &&
    !fromRoute &&
    typeof switchingTo === "object";

  if (showSwitchOverlay) {
    const name = switchingTo.name || "";
    const label = (I18n.switching_to_business || "Switching to {name}...").replace(
      "{name}",
      name
    );

    const overlay = (
      <div className={styles.switchOverlay} role="status" aria-live="polite">
        <div className={styles.switchCard}>
          <div className={styles.switchVisual}>
            <span className={styles.ringSpin} aria-hidden>
              <AvatarRingIcon className={styles.ringSvg} />
            </span>
            <div className={styles.avatarWrap}>
              {switchingTo.imageUrl ? (
                <img
                  src={switchingTo.imageUrl}
                  alt=""
                  className={styles.avatarImg}
                  draggable={false}
                />
              ) : (
                <span className={styles.avatarLetter}>
                  {name.trim().charAt(0).toUpperCase() || "?"}
                </span>
              )}
            </div>
          </div>
          <p className={styles.switchText}>{label}</p>
        </div>
      </div>
    );

    return typeof document !== "undefined"
      ? createPortal(overlay, document.body)
      : overlay;
  }

  return (
    <div
      className={
        fromAuth
          ? "AuthLoader"
          : fromRoute
          ? "fullScreenLoader posConfiguringLoader"
          : `fullScreenLoader ${className}`
      }
    >
      {/* <CircularProgress size={24} className="loaderCircle fullScreenCircle" /> */}
      <DotsLoader />
      {fromRoute ? (
        <p className="fontSize18 whiteColor marginTop15">
          Configuring RUPIN
        </p>
      ) : null}
    </div>
  );
};

export default BusinessLoader;
